import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Routes, Route, useParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Alert, Container, Typography } from '@mui/material';
import { 
  fetchAllChitalishta, 
  fetchChitalishteBySlug,
  fetchInformationCardsByChitalishte,
  clearCurrentChitalishte,
  clearError,
  fetchTotalCount
} from '../store/slices/chitalishtaSlice';
import { 
  selectAllChitalishta,
  selectCurrentChitalishte,
  selectChitalishtaLoading,
  selectChitalishtaError,
  selectTotalCount
} from '../store/slices/chitalishtaSlice';
// ПРЕМАХНЕТЕ ChitalishteFilters от тук
import ChitalishteList from '../components/chitalishte/ChitalishteList';
import ChitalishteDetail from '../components/chitalishte/ChitalishteDetail';
import MainLayout from '../components/layout/MainLayout';

// Компонент за детайлите на читалището
const ChitalishteDetailWrapper = () => {
  const params = useParams();
  const slug = params['*'];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const chitalishte = useSelector(selectCurrentChitalishte);
  const loading = useSelector(selectChitalishtaLoading);
  const error = useSelector(selectChitalishtaError);

  useEffect(() => {
    if (slug) {
      // console.log('🔍 Loading chitalishte with slug:', slug);
      // Използваме новия action за търсене по slug
      dispatch(fetchChitalishteBySlug(slug)).then((result) => {
        if (result.payload && result.payload.id) {
          // console.log('✅ Loaded chitalishte:', result.payload.name);
          // След като намерим читалището, зареждаме информационните карти по ID
          dispatch(fetchInformationCardsByChitalishte(result.payload.id));
        } else {
          console.error('❌ Failed to load chitalishte');
        }
      });
    }
  }, [slug, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearCurrentChitalishte());
    };
  }, [dispatch]);

  if (loading && !chitalishte) {
    return (
      <MainLayout>
        <Box
        sx={{
          minHeight: '60vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white'
        }}
      >
        <CircularProgress 
          size={60} 
          sx={{ color: 'white', mb: 2 }}
        />
        <Typography variant="h5" sx={{ fontWeight: 300 }}>
          Зареждане на информацията...
        </Typography>
      </Box>
      </MainLayout>
    );
  }

  if (error) {
    return (
      <MainLayout>
        <Container sx={{ py: 4 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          Грешка при зареждане на данните: {error}
        </Alert>
      </Container>
      </MainLayout>
    );
  }

  if (!chitalishte) {
    return (
      <MainLayout>
        <Container sx={{ py: 4 }}>
        <Alert severity="warning">
          Читалището не е намерено
        </Alert>
      </Container>
      </MainLayout>
    );
  }

  return (
  <MainLayout>
    <ChitalishteDetail chitalishte={chitalishte} />
  </MainLayout>
  );
};

// Компонент за списъка с читалища
const ChitalishteListWrapper = () => {
  const dispatch = useDispatch();
  const chitalishta = useSelector(selectAllChitalishta);
  const loading = useSelector(selectChitalishtaLoading);
  const error = useSelector(selectChitalishtaError);
  const totalCount = useSelector(selectTotalCount);

  useEffect(() => {
    dispatch(fetchAllChitalishta({ page: 0, size: 12 }));
    dispatch(fetchTotalCount());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearError());
    };
  }, [dispatch]);

  if (loading && chitalishta.length === 0) {
    return (
     <MainLayout>
       <Box
        sx={{
          minHeight: '60vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white'
        }}
      >
        <CircularProgress 
          size={60} 
          sx={{ color: 'white', mb: 2 }}
        />
        <Typography variant="h5" sx={{ fontWeight: 300 }}>
          Зареждане на читалищата...
        </Typography>
      </Box>
     </MainLayout>
    );
  }

  if (error) {
    return (
     <MainLayout>
       <Container sx={{ py: 4 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          Грешка при зареждане на данните: {error}
        </Alert>
        <Alert severity="info">
          В момента данните се зареждат от сървъра. Моля, опитайте отново или се свържете с администратор.
        </Alert>
      </Container>
     </MainLayout>
    );
  }

  return (
   <MainLayout>
     <Box sx={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)' }}>
      {/* ПРЕМАХНЕТЕ ChitalishteFilters от тук */}
      <ChitalishteList 
        chitalishta={chitalishta} 
        totalCount={totalCount}
        loading={loading}
      />
    </Box>
   </MainLayout>
  );
};

// Главен компонент
const ChitalishtePage = () => {
  return (
    <Routes>
      <Route path="/" element={<ChitalishteListWrapper />} />
      <Route path="*" element={<ChitalishteDetailWrapper />} />
    </Routes>
  );
};

export default ChitalishtePage;